import { downloadCsv, rowsToCsv } from '../../../creatives/data/csv';
import type { CompetitionElementRow, CompetitionElementsData } from './api';

export { downloadCsv };

const STATUS_LABEL: Record<CompetitionElementRow['status'], string> = {
  never_used: 'Never used',
  rarely_used: 'Rarely used',
  well_covered: 'Well covered',
};

export function competitionElementsToCsv(
  rows: CompetitionElementRow[],
  competitorsById: CompetitionElementsData['competitorsById'],
): string {
  const header = [
    'Category',
    'Feature category',
    'Feature',
    'Tag',
    'They use it %',
    'Who uses it',
    'Top brand',
    'Top brand %',
    'You use it %',
    'Status',
  ];
  const dataRows = rows.map((row) => [
    row.category,
    row.featureCategory,
    row.feature,
    row.tag,
    `${Math.round(row.competitorShare * 100)}`,
    row.competitors
      .map((competitorId) => competitorsById[competitorId]?.competitorName ?? competitorId)
      .join('; '),
    row.topBrand === null
      ? ''
      : (competitorsById[row.topBrand.competitorId]?.competitorName ?? row.topBrand.competitorId),
    row.topBrand === null ? '' : `${Math.round(row.topBrand.share * 100)}`,
    `${Math.round(row.clientShare * 100)}`,
    STATUS_LABEL[row.status],
  ]);
  return rowsToCsv([header, ...dataRows]);
}
